import React from 'react'
import createReactClass from 'create-react-class'

var QuantityInput = createReactClass({
	getDefaultProps: function() {
		return { wrapperClassName: '', quantityClassName: 'ope-quantity '}
	},

	changeHandler: function(event) {
		this.props.callback(event.target.value);
	},

	/**
	 * Function for decreasing the quantity of a product-item with 1
	 */
	decreaseHandler: function(event) {
		if(this.props.value > 0) {
			if(this.props.callback) {
				this.props.callback(this.props.value-1);
			}
		}
	},

	/**
	 * Function for increasing the quantity of a product-item with 1
	 */
	increaseHandler: function(event) {
		if(this.props.callback) {
			this.props.callback(this.props.value + 1);
		}
	},

	saveChangedQuantity: function() {
		var value = this.props.value;
		if(value) {
			if(this.props.callback) {
				this.props.callback(value);
			}
		}
	},

	render: function() {

		var options = [];
		for (var i = 1; i <= 100; i++) {
			options.push(<option key={i} value={i}>{i}</option>);
		}

		var className = this.props.wrapperClassName;

		return (
			<div className="ope-product-list__item__quantity__container">
				<div className={className}>
					<select className="ope-quantity-select" onChange={this.changeHandler} value={this.props.value} >
						{options}
					</select>
				</div>
				{
					this.props.removeHandler && <div className="ope-product-list__item__quantity small-3 medium-1 columns ope-grid-column-nopadding">
						<div className="ope-product-list__item__deleteLink" onClick={this.props.removeHandler}>{_("Delete")}</div>
					</div>
				}
			</div>
		);
	}
});

export default QuantityInput;
